import { X } from 'lucide-react';
import { SmartTagInput } from './SmartTagInput';
import type { BuyerPersona } from '@/types/tenant';

export interface PersonaCardProps {
  data: BuyerPersona;
  onChange: (next: BuyerPersona) => void;
  onRemove: () => void;
  /** Avatar background color */
  accent: string;
}

export function PersonaCard({ data, onChange, onRemove, accent }: PersonaCardProps) {
  return (
    <div className="border border-border rounded-xl bg-card p-3.5 flex flex-col gap-2.5 relative min-h-[230px]">
      <div className="flex items-center gap-2.5">
        <div
          className="w-8 h-8 rounded-md text-white grid place-items-center text-[13px] font-bold flex-shrink-0"
          style={{ background: accent }}
        >
          {(data.segment_name || '?').slice(0, 1).toUpperCase()}
        </div>
        <input
          value={data.segment_name || ''}
          onChange={(e) => onChange({ ...data, segment_name: e.target.value })}
          placeholder="Segment name"
          className="flex-1 border-none outline-none text-[14.5px] font-semibold bg-transparent"
        />
        <button
          type="button"
          onClick={onRemove}
          className="w-6 h-6 grid place-items-center border-none bg-transparent text-muted-foreground hover:text-foreground cursor-pointer rounded"
        >
          <X className="size-3" />
        </button>
      </div>

      <input
        value={data.demographics || ''}
        onChange={(e) => onChange({ ...data, demographics: e.target.value })}
        placeholder="Demographics — e.g. age 35–55, suburban homeowner"
        className="px-2.5 py-1.5 text-[13px] rounded-lg border border-border bg-card outline-none focus:border-coral focus:ring-[3px] focus:ring-coral/15 transition-[border-color,box-shadow] duration-150"
      />

      <div>
        <div className="text-[11px] text-muted-foreground font-semibold mb-1 uppercase tracking-wider">
          Pain points
        </div>
        <SmartTagInput
          value={data.pain_points || []}
          onChange={(v) => onChange({ ...data, pain_points: v })}
          placeholder="What problems do they need solved?"
          suggestions={['Hidden fees', 'Slow response', 'No follow-up', 'Poor cleanup']}
        />
      </div>

      <div>
        <div className="text-[11px] text-muted-foreground font-semibold mb-1 uppercase tracking-wider">
          Objections
        </div>
        <SmartTagInput
          value={data.objections || []}
          onChange={(v) => onChange({ ...data, objections: v })}
          placeholder="Why do they hesitate?"
          suggestions={['Too expensive', 'Trust', 'Timing', 'Already have a provider']}
        />
      </div>
    </div>
  );
}
